import React, {useState} from 'react';
import Button from '@mui/material/Button';



function QuantityField(props) {

  const [counter , setCounter] = useState(0);
  const incrementHandler =() => {
    setCounter((val) => val + 1);
  }
  const decrementHandler =() => {
    setCounter((val) => val - 1);
  }



  return (
    <div className="PM_QuantityFieldContainer">
        <Button onClick={decrementHandler}>-</Button>
        <input className='PM_QuantityFieldInput' type='text' value={counter} />
        <Button onClick={incrementHandler}>+</Button>
    </div>
  );
}

export default QuantityField;
